module.exports = __webpack_public_path__ + "static/sherpadesk-ff63b4bdedaaf4ff4594158f06bd233b.png";